import { render, staticRenderFns } from "./StrengthsSection.vue?vue&type=template&id=e2097b6c&scoped=true"
import script from "./StrengthsSection.vue?vue&type=script&lang=js"
export * from "./StrengthsSection.vue?vue&type=script&lang=js"
import style0 from "./StrengthsSection.vue?vue&type=style&index=0&id=e2097b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2097b6c",
  null
  
)

export default component.exports